import { useMutation } from '@tanstack/react-query';

import { importCompanyPayments } from '@widgets/AddPayments/lib/model/api/importCompanyPayments';

export const useImportCompanyPaymentsQuery = () =>
    useMutation({
        mutationKey: ['importCompanyPayments'],
        mutationFn: importCompanyPayments,
    });
